export default "__VITE_ASSET__DnSDh2c6__"